// Third party
import React, { useState } from "react";

// Our components
import { Box, Typography } from "@mui/material";
import { AlignCenter, StyledButton } from "../components";
import { Navigate } from "react-router-dom";
import VideoContainer from "../features/VideoContainer";
import useTranslatePageText from "@natklok/hooks/useTranslatePageText";

const ForTeachers: React.FC = () => {
  const [redirect, setRedirect] = useState(false);
  const translate = useTranslatePageText();

  if (redirect) return <Navigate to="/multiplayer/skapa" />;

  return (
    <AlignCenter withMaxWidth>
      <Box>
        <Typography variant="h3" style={{ margin: "24px 0" }}>
          {translate("forTeachers.welcome")}
        </Typography>
        <Typography variant="subtitle1" style={{ fontSize: 22, lineHeight: 1.2, margin: "16px 0" }}>
          {translate("forTeachers.intro")} <b>{translate("forTeachers.highlightedPart")}</b>
        </Typography>
        <VideoContainer youtubeId="t0cyaZRsSTM" />
        <br />
        <StyledButton
          size="big"
          fullWidth
          style={{ maxWidth: 300 }}
          onClick={() => setRedirect(true)}
        >
          {translate("forTeachers.createQuiz")}
        </StyledButton>
        <Typography variant="h4" style={{ margin: "48px 0 0 0" }}>
          {translate("forTeachers.questions")}
        </Typography>
        <Typography variant="subtitle1" style={{ fontSize: 20, lineHeight: 1.2, margin: "16px 0" }}>
          {translate("forTeachers.howToUse")}{" "}
          <a style={{ color: "white" }} href="mailto:info@stoldskyddsforeningen.se">
            info@stoldskyddsforeningen.se
          </a>
        </Typography>
      </Box>
    </AlignCenter>
  );
};
export default ForTeachers;
